import { MaterialConfiguration } from './material-configuration';
import { TranslateHandlebarsPipe } from 'app/shared/pipes/translate-handlebars.pipe';
import { LinkActions } from '../../common/base-card-configuration';

export class ExternalVideoConfiguration extends MaterialConfiguration {
    constructor(course: any, translateHandlebarsPipe: TranslateHandlebarsPipe) {
        super();
        this.tagType = 'externalLink';
        this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/video.png';
        this.classType = 'Video';
        this.multiContent = course.contents.length > 1;
        this.subtitle = 'branded.portal.courses.assignment.material.external-vdeo.subtitle';
        this.expired = !course.enabled;
        this.clickable = !this.expired;
        this.action = LinkActions.SSO;
        this.links = [{
            disabled: this.expired,
            tooltip: this.expired ? 'branded.portal.courses.assignment.external-vdeo.launch.tooltip' : null,
            url: this.expired ? '' : course.path,
            text: 'branded.portal.courses.assignment.external-vdeo.launch.text',
            type: LinkActions.SSO
        }];
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/external-video-configuration.ts